<template>
  <b-modal 
    ref="addressUpdateModal"
    no-fade
    title="Update Address"
    hide-footer
  >
    <div class="address-modal-content">
      <h4 class="my-5">Address Details</h4>
      <p>Please enter your address details below by either searching using the postcode finder or manually typing into the fields below.</p>
      <!-- UK Postcode lookup -->
      <UkPostcode 
        addressOwner="user"
        formName="addressUpdate"
        labelText="Home Address - Enter postcode"
        placeholderText="Postcode Finder"
        @postcodeSelected="(e) => handleAddressSelect(e)"
      />
      <!-- EIRCODE LOOKUP -->
      <b-form-group v-if="referer === 'IE'">
        <Autoaddress
          licencekey="2e9c9e91-eda5-472e-ae24-7d3569bec687"
          vanityMode="true"
          addressProfile="Demo5LineV2"
          country="ie"
          language="en"
          noResultFoundLabel="No search results have been found.Please enter address manually below."
          @onAddressFound="handleAddressSelect($event)"
          placeHolderLabel="Eircode Finder"
        />
      </b-form-group>
      <!-- Address Line 1 -->
      <b-form-group>
        <b-form-input
          :value="address1"
          v-model="address1"
          placeholder="Address Line 1"
          :class="{
            'is-valid': !$v.address1.$error && address1,
            'is-invalid': $v.address1.$error
          }"
        ></b-form-input>
      </b-form-group>
      <!-- Address Line 2 -->
      <b-form-group>
        <b-form-input
          :value="address2"
          v-model="address2"
          placeholder="Address Line 2"
        ></b-form-input>
      </b-form-group>
      <!-- Address Line 3 -->
      <b-form-group>
        <b-form-input
          :value="address3"
          v-model="address3"
          placeholder="Address Line 3"
        ></b-form-input>
      </b-form-group>
      <!-- Address Line 4 -->
      <b-form-group>
        <b-form-input
          :value="address4"
          v-model="address4"
          placeholder="Address Line 4"
        ></b-form-input>
      </b-form-group>
      <!-- Postcode -->
      <b-form-group>
        <b-form-input
          :value="postcode.toUpperCase()"
          v-model="postcode"
          :placeholder="referer==='UK' ? 'Postcode' : 'Eircode'"
          :class="{
            'is-valid': !$v.postcode.$error && postcode,
            'is-invalid': $v.postcode.$error
          }"
        ></b-form-input>
      </b-form-group>
      <b-button
        variant="success"
        @click="handleAddressUpdate"
      >
        Update Address
      </b-button>
    </div>
    <b-alert
      v-if="showAlert"
      show
      :variant="alertType"
    >
      {{ alertText }}
    </b-alert>
  </b-modal>    
</template>

<script>
  import { required } from 'vuelidate/lib/validators'
  import Autoaddress from '@autoaddress.ie/autoaddress-vue/src/Autoaddress'
  import UkPostcode from '../UkPostcode.vue'
  import { mapGetters } from 'vuex'
  import { updateAddress } from '../../services/api'

  export default {
    components: {
      Autoaddress,
      UkPostcode
    },
    computed: {
      ...mapGetters({
      getToken: 'authStore/getToken',
      getRecruit: 'authStore/getRecruit'
    }),
    },
    data () {
      return {
        referer: window.siteVar.referer,
        address1: '',
        address2: '',
        address3: '',
        address4: '',
        postcode: '',
        showAlert: false,
        alertText: '',
        alertType: ''
      }
    },
    methods: {
      openModal (addressData) {
        this.address1 = addressData.address1
        this.address2 = addressData.address2
        this.address3 = addressData.address3
        this.address4 = addressData.address4
        this.postcode = addressData.postcode
        this.$v.$touch()
        this.$refs.addressUpdateModal.show()
      },
      handleAddressSelect (e) {
        const addressArray = e && e.address ? e.address.split(',') : e.postalAddress
        const postcode = e.postcode
        this.address1 = addressArray && addressArray.length && addressArray[0] ? addressArray[0].trim() : ''
        this.address2 = addressArray && addressArray.length && addressArray[1] ? addressArray[1].trim() : ''
        this.address3 = addressArray && addressArray.length && addressArray[2] ? addressArray[2].trim() : ''
        this.address4 = addressArray && addressArray.length && addressArray[3] ? addressArray[3].trim() : ''
        this.postcode = postcode
      },
      async handleAddressUpdate () {
        this.$v.$touch()
        if (this.$v && !this.$v.$invalid) {
          try {
            const addressData = {
              address1: this.address1,
              address2: this.address2,
              address3: this.address3,
              address4: this.address4,
              postcode: this.postcode
            }

            const res = await updateAddress(this.getToken, addressData)
            if (res && res.data && res.data.success) {
              this.showAlert = true
              this.alertType = 'success'
              this.alertText = 'Address updated'
              setTimeout(() => {
                this.showAlert = false
                this.alertType = ''
                this.alertText = ''
                location.reload()
                this.$refs.addressUpdateModal.hide()
              }, 3000)
            } else {
              this.showAlert = true
              this.alertType = 'danger'
              this.alertText = 'Please ensure all required fields are complete'
              setTimeout(() => {
                this.showAlert = false
                this.alertType = ''
                this.alertText = ''
              }, 3000)
            }
          } catch (err) {
            this.showAlert = true
            this.alertType = 'danger'
            this.alertText = 'Internal server error, please try again'
            setTimeout(() => {
              this.showAlert = false
              this.alertType = ''
              this.alertText = ''
            }, 3000)
          }
        } else {
          this.showAlert = true
          this.alertType = 'danger'
          this.alertText = 'Please ensure all required fields are complete'
          setTimeout(() => {
            this.showAlert = false
            this.alertType = ''
            this.alertText = ''
          }, 3000)
        }
      }
    },
    validations: {
      address1: {
        required: required
      },
      postcode: {
        required: required
      }
    }
  }
</script>

<style scoped>
.address-modal-content {
  padding: 20px !important;
}
.form-control {
  border: 1px solid #ced4da !important;
}
</style>